export default "__VITE_ASSET__bJH3eO2f__"